import { NavLink, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  DollarSign,
  Users,
  GitBranch,
  Activity,
  AlertTriangle,
  Wrench,
  Undo2,
  Smartphone,
  Megaphone,
  ShieldAlert,
  Cloud,
  Star,
} from "lucide-react";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

const groups = [
  {
    label: "Insights",
    items: [
      { title: "Overview", url: "/admin/overview", icon: LayoutDashboard },
      { title: "Revenue", url: "/admin/revenue", icon: DollarSign },
      { title: "Users", url: "/admin/users", icon: Users },
      { title: "Funnel", url: "/admin/funnel", icon: GitBranch },
      { title: "Engagement", url: "/admin/engagement", icon: Activity },
    ],
  },
  {
    label: "Operations",
    items: [
      { title: "Stability", url: "/admin/stability", icon: AlertTriangle },
      { title: "AI & Storage", url: "/admin/operations", icon: Wrench },
      { title: "Refunds", url: "/admin/refunds", icon: Undo2 },
      { title: "Mobile (Play)", url: "/admin/mobile", icon: Smartphone },
    ],
  },
  {
    label: "System",
    items: [
      { title: "Broadcasts", url: "/admin/broadcasts", icon: Megaphone },
      { title: "Featured", url: "/admin/featured", icon: Star },
      { title: "Security", url: "/admin/security", icon: ShieldAlert },
      { title: "Cloud", url: "/admin/cloud", icon: Cloud },
    ],
  },
];

export function AdminSidebar() {
  const { pathname } = useLocation();
  return (
    <Sidebar collapsible="icon">
      <SidebarContent>
        {groups.map((g) => (
          <SidebarGroup key={g.label}>
            <SidebarGroupLabel>{g.label}</SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {g.items.map((item) => {
                  const active = pathname === item.url || pathname.startsWith(item.url + "/");
                  return (
                    <SidebarMenuItem key={item.url}>
                      <SidebarMenuButton asChild isActive={active}>
                        <NavLink to={item.url} className="flex items-center gap-2">
                          <item.icon className="h-4 w-4" />
                          <span>{item.title}</span>
                        </NavLink>
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  );
                })}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        ))}
      </SidebarContent>
    </Sidebar>
  );
}
